export enum CreateAssignmentDesignTabEnum {
  PRELOADED_ASSIGNMENTS = "Preloaded Assignments",
  ASSIGNMENT_DESIGNER = "Assignment Designer",
}

export enum AssignmentDesignerStepsEnum {
  ASSIGNMENT_CONTENT = "Content",
  BASIC_INFORMATION = "Basic Information",
  ASSIGNMENT_SECTIONS = "Assignment Sections",
  ASSIGNMENT_DETAILS = "Additional Details",
}

export enum QuestionSelectionEnum {
  AUTOMATIC = 1,
  MANUAL = 2,
}

export enum AssignmentStatusEnum {
  DRAFT = 1,
  FINALIZED = 2,
  PUBLISHED = 3,
  EXPIRED = 4,
}

export enum ReplacementQuestionTypeEnum {
  EASIER = "Easier",
  HARDER = "Harder",
  SIMILAR = "Similar",
}

export enum QuestionCategoryOptionsEnum {
  ALL = 1,
  ASSIGNMENT = 3,
  RECOMMENDED = 9,
  INSTITUTE = 10,
}

export enum QuestionPaperTemplateEnum {
  SINGLE_COLUMN = "QP_SINGLE_COL",
  DOUBLE_COLUMN = "QP_DOUBLE_COL",
}
